(() => {
  if (window.__styledWordScriptLoaded) return;
  window.__styledWordScriptLoaded = true;

  const TITLE_SELECTOR =
    '.product-meta__title, .product-item__info-inner h3';

  const TARGET_WORDS = ['עודפים', 'תצוגה'];

  function applyStyledWord() {
    if (window.location.pathname === '/') return;

    document
      .querySelectorAll(TITLE_SELECTOR)
      .forEach(title => {
        if (title.querySelector('.styled-word')) return;

        const walker = document.createTreeWalker(
          title,
          NodeFilter.SHOW_TEXT
        );

        const textNodes = [];

        while (walker.nextNode()) {
          textNodes.push(walker.currentNode);
        }

        for (let index = textNodes.length - 1; index >= 0; index--) {
          const textNode = textNodes[index];
          const text = textNode.nodeValue || '';

          const targetWord = TARGET_WORDS.find(word =>
            new RegExp(`${word}\\s*$`).test(text)
          );

          if (!targetWord) continue;

          const wordPosition =
            text.lastIndexOf(targetWord);

          const fragment =
            document.createDocumentFragment();

          fragment.appendChild(
            document.createTextNode(
              text.slice(0, wordPosition)
            )
          );

          const span =
            document.createElement('span');

          span.className = 'styled-word';
          span.textContent = targetWord;

          fragment.appendChild(span);

          fragment.appendChild(
            document.createTextNode(
              text.slice(
                wordPosition + targetWord.length
              )
            )
          );

          textNode.parentNode.replaceChild(
            fragment,
            textNode
          );

          break;
        }
      });
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      applyStyledWord();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyStyledWord,
      { once: true }
    );
  } else {
    applyStyledWord();
  }

  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );

  const observer = new MutationObserver(
    scheduleUpdate
  );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();